import gql from "graphql-tag";

export const SET_TOKEN = gql`
  mutation SetToken($token: String = null, $useSession: Boolean = false) {
    setToken(token: $token, useSession: $useSession) @client
  }
`;

export const INCREMENT_NOTIFICATION_LENGTH = gql`
  mutation IncrementNotificationsLength($looked: Boolean!) {
    incrementNotificationsLength(looked: $looked) @client
  }
`;

export const UPDATE_NOTIFICATIONS_LENGTH = gql`
  mutation UpdateNotificationsLength($length: Int!, $looked: Boolean!) {
    updateNotificationsLength(length: $length, looked: $looked) @client
  }
`;
